import { Controller } from "@hotwired/stimulus";

// Coordinates checkout multi-step flow and progress indicator
// Review step (invoice) has no progress bar; payment steps show progress
export default class extends Controller {
  static values = { step: String };
  static targets = ["progress"];

  connect() {
    this.updateProgress();
  }

  stepValueChanged() {
    this.updateProgress();
  }

  updateProgress() {
    if (!this.hasProgressTarget) return;

    // Hide progress bar on review step (invoice page)
    if (this.stepValue === "review") {
      this.progressTarget.classList.add("hidden");
      return;
    }

    this.progressTarget.classList.remove("hidden");

    const steps = ["payment_method", "payment"];
    const currentIndex = steps.indexOf(this.stepValue);

    const stepElements =
      this.progressTarget.querySelectorAll("[data-step-index]");
    stepElements.forEach((el, index) => {
      const isActive = index === currentIndex;
      const isCompleted = index < currentIndex;

      el.classList.toggle("bg-cta", isActive || isCompleted);
      el.classList.toggle("text-white", isActive || isCompleted);
      el.classList.toggle("bg-gray-200", !isActive && !isCompleted);
      el.classList.toggle("text-gray-500", !isActive && !isCompleted);
    });
  }
}
